import { render, staticRenderFns } from "./UserCarts.vue?vue&type=template&id=7552353c"
import script from "./UserCarts.vue?vue&type=script&lang=js"
export * from "./UserCarts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports